import '@Skeleton/Common.scss';

import Skeleton from '@Skeleton/Skeleton';
import TextSkeleton from '@Skeleton/Text';
import SpacerSkeleton from '@Skeleton/Spacer';
import RectSkeleton from '@Skeleton/Rectangle';

export default Skeleton;

export { SpacerSkeleton, TextSkeleton, RectSkeleton };
